<template>
    <div class="py-2">
        <strong>{{ $tc('resources.planPackage.name', 1) }}</strong
        >: {{ planPackage.name }}<br />
        <strong>{{ $t('planPackages.form.labels.price') }}</strong
        >: {{ planPackage.formattedPrice }}<br />
    </div>
</template>

<script>
export default {
    props: {
        planPackage: {
            type: Object,
            required: true,
        },
    },
}
</script>
